import { useEffect } from 'react';

interface SeoOptions {
  title: string;
  description?: string;
  keywords?: string;
}

const setMeta = (name: string, content: string) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

const setOg = (property: string, content: string) => {
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

export function useSeo({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    setOg('og:title', title);
    if (description) {
      setMeta('description', description);
      setOg('og:description', description);
    }
    if (keywords) {
      setMeta('keywords', keywords);
    }
  }, [title, description, keywords]);
}